import { Injectable } from '@angular/core';
import { T4BoxService } from './t4Box.service';

/**
 * Specialized T4BoxService for custom benefit request form
 * Loads benefit_selectable scope (includes Box 14) instead of secondary
 */
@Injectable()
export class BenefitSelectableT4BoxService extends T4BoxService {
    constructor() {
        super();
        // Parent constructor calls this.load() which is overridden below
    }

    protected override load(): void {
        this.loadWithScope('benefit_selectable');
    }
}
